// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixData from 'wix-data';

$w.onReady(function () {
	let localDate = new Date();
    let yearValue = localDate.getFullYear();
    let monthValue = localDate.getMonth();
    let dayValue = localDate.getDate();
    let dateValue = new Date(yearValue,monthValue,dayValue);

    let filter = wixData.filter();

	// filtre sur A la une 
    filter = filter.eq("aLaUne",true);
	// filtre sur la date de fin de parution
	filter = filter.ge("dateDeFinDeParution",dateValue).or(filter.eq("dateDeFinDeParution",null));
    


    $w("#datasetDonnees").setFilter(filter);
});